/**
 * Create by zxp on 2017/3/7
 *
 */
// 在这个页面引入有关全局加载、全局提示。。。的vuex
import Vue from 'vue'
import Vuex from 'vuex'

import loading from './modules/loading'
import toast from './modules/toast'
import isRefresh from './modules/isRefresh'
import user from './modules/user'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    toast,
    loading,
    isRefresh,
    user
  }
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js